import Box from "@mui/material/Box";

import Content from "../Content";

const DesktopSidebar = () => {
  return (
    <Box
      sx={{
        display: {
          xs: "none",
          sm: "none",
          md: "block",
          lg: "block",
          xl: "block",
        },
        position: "fixed",
        height: "100svh",
        boxShadow: "6px 0px 3px -3px #DEE4EB",
        zIndex: 1400,
      }}
    >
      <Content />
    </Box>
  );
};

export default DesktopSidebar;
